import React, { useEffect, useState } from "react";
import cosmeticConfig from "../../../config/cosmeticConfig";
import {
    getRecoObjects,
    followButtonClicked,
    unFollowButtonClicked
} from "../../util/commonFunctions";

const ExpertReco = (props) => {

    const [experts, setExperts] = useState([]);

    useEffect(() => {
        if (props.fetchNew && props.show) {
            getRecoObjects(getRecoExpertsRespHandler, props.currentLanguage, localStorage.getItem("token"), [], cosmeticConfig.reco_object_on_onboarding.MAX_EXPERT, false, false, true);
        }
    }, [props.show]);

    const getRecoExpertsRespHandler = (response, error) => {
        setExperts(response);
    }

    const followObject = (objectId) => {
        followButtonClicked(followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    }

    const unFollowObject = (objectId) => {
        unFollowButtonClicked(unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
    }

    const followButtonClickedRespHandler = (response, error) => {
        updateFollowBtnStatus(response.objectId, response.objectType);
    }

    const unFollowButtonClickedRespHandler = (response, error) => {
        updateFollowBtnStatus(response.objectId, response.objectType);
    }

    const updateFollowBtnStatus = (objectId, objectType) => {
        followStatusUpdaterFn( objectId );
    }

    const followStatusUpdaterFn = ( objectId ) => {
        let updated_objects = [];
        Object.values(experts).map(values => {
            if (values?.id == objectId) {
                values.isFollowing = !values.isFollowing;
            }
            updated_objects.push(values);
        });
        setExperts(updated_objects);
    }

    return (
        <div className={props.show ? "popup_register_block" : "hide"}>
            <h3 className="question">Experts you may be interested in following<span>You can search and add more later from your Watchlist</span></h3>
            <div className="onboarding-topics-list onboarding-series">
                <ul>
                    {experts.length > 0 && experts.map((expert, expertIndex) => {
                        return (
                            <li key={`followOnboardingRecoExpertes-${expertIndex}`}>
                                <div
                                    className={expert.isFollowing ? "wrap-topics active" : "wrap-topics"}
                                    onClick={expert.isFollowing ? () => unFollowObject(expert.id) : () => followObject(expert.id)}
                                >
                                    <div className="topic-left">
                                        <div className="image-block expert-circle">
                                            <img src={expert.url} />
                                        </div>
                                        <div className="wrap-left-text">
                                            <strong>{expert.name}</strong>
                                            <div className="onboarding-expert">
                                                <div>{expert.role} <em>|</em></div>
                                                <div>{expert.company} <em>|</em></div>
                                            </div>
                                        </div>
                                    </div>
                                    <small></small>
                                </div>
                            </li>
                        );
                    })
                    }
                </ul>
            </div>
        </div>
    );
};

export default ExpertReco;
